
import type { Organism } from '@verndale/core';
// ==> THIS FILE IS AUTO GENERATED, DO NOT EDIT DIRECTLY <== //

const modulesScaffold: Organism[] = [
  
  {
    name: 'header',
    loader: () => import('./modules/header'),
    
  },

  {
    name: 'alert-banner',
    loader: () => import('./modules/alert-banner'),
    
  },

  {
    name: 'breadcrumbs',
    
    styles: () => import('../../src/scss/modules/breadcrumbs.scss'),
  },

  {
    name: 'image-masthead-carousel',
    loader: () => import('./modules/image-masthead-carousel'),
    
  },

  {
    name: 'homepage-masthead',
    loader: () => import('./modules/homepage-masthead'),
    
  },

  {
    name: 'project-masthead-carousel',
    loader: () => import('./modules/project-masthead-carousel'),
    
  },

  {
    name: 'city-listing-masthead',
    loader: () => import('./modules/city-listing-masthead'),
    
  },

  {
    name: 'blog-category-masthead',
    loader: () => import('./modules/blog-category-masthead'),
    
  },

  {
    name: 'share',
    loader: () => import('./modules/share'),
    
  },

  {
    name: 'navigation-jumplinks',
    loader: () => import('./modules/navigation-jumplinks'),
    styles: () => import('../../src/scss/modules/navigation-jumplinks.scss'),
  },

  {
    name: 'tabbed-featured-content',
    loader: () => import('./modules/tabbed-featured-content'),
    styles: () => import('../../src/scss/modules/tabbed-featured-content.scss'),
  },

  {
    name: 'footer',
    loader: () => import('./modules/footer'),
    styles: () => import('../../src/scss/modules/footer.scss'),
  },

  {
    name: 'accordion',
    loader: () => import('./modules/accordion.js'),
    styles: () => import('../scss/modules/accordion.scss'),
  },

  {
    name: 'cookie-banner',
    
    styles: () => import('../../src/scss/modules/cookie-banner.scss'),
  },

  {
    name: 'content-section-row',
    
    styles: () => import('../../src/scss/modules/content-section-row.scss'),
  },

  {
    name: 'logo-carousel-row',
    loader: () => import('./modules/logo-carousel-row'),
    styles: () => import('../../src/scss/modules/logo-carousel-row.scss'),
  },

  {
    name: 'card-row',
    
    styles: () => import('../../src/scss/modules/card-row.scss'),
  },

  {
    name: 'icon-cards',
    
    styles: () => import('../../src/scss/modules/icon-cards.scss'),
  },

  {
    name: 'masonry-gallery',
    loader: () => import('./modules/masonry-gallery'),
    styles: () => import('../../src/scss/modules/masonry-gallery.scss'),
  },

  {
    name: 'link-grid',
    
    styles: () => import('../../src/scss/modules/link-grid.scss'),
  },

  {
    name: 'press-release-company-information',
    
    styles: () => import('../../src/scss/modules/press-release-company-information.scss'),
  },

  {
    name: 'content-grid',
    loader: () => import('./modules/content-grid'),
    styles: () => import('../../src/scss/modules/content-grid.scss'),
  },

  {
    name: 'tabbed-container',
    loader: () => import('./modules/tabbed-container'),
    
  },

  {
    name: 'testimonial-carousel',
    loader: () => import('./modules/testimonial-carousel'),
    styles: () => import('../../src/scss/modules/testimonial-carousel.scss'),
  },

  {
    name: 'masked-image-with-content',
    
    styles: () => import('../../src/scss/modules/masked-image-with-content.scss'),
  },

  {
    name: 'call-to-action-row-with-image',
    
    styles: () => import('../../src/scss/modules/call-to-action-row-with-image.scss'),
  },

  {
    name: 'call-to-action-row-with-video',
    
    styles: () => import('../../src/scss/modules/call-to-action-row-with-video.scss'),
  },

  {
    name: 'call-to-action-row-with-background',
    
    styles: () => import('../../src/scss/modules/call-to-action-row-with-background.scss'),
  },

  {
    name: 'call-to-action-row-centered',
    
    styles: () => import('../../src/scss/modules/call-to-action-row-centered.scss'),
  },

  {
    name: 'payment-methods-block',
    
    styles: () => import('../../src/scss/modules/payment-methods-block.scss'),
  },

  {
    name: 'contractor-details',
    
    styles: () => import('../../src/scss/modules/contractor-details.scss'),
  },

  {
    name: 'certifications-block',
    loader: () => import('./modules/certifications-block'),
    styles: () => import('../../src/scss/modules/certifications-block.scss'),
  },

  {
    name: 'contractor-reviews',
    loader: () => import('./modules/contractor-reviews'),
    styles: () => import('../../src/scss/modules/contractor-reviews.scss'),
  },

  {
    name: 'image-row-with-fact-icons',
    
    styles: () => import('../../src/scss/modules/image-row-with-fact-icons.scss'),
  },

  {
    name: 'promo-cards',
    
    styles: () => import('../../src/scss/modules/promo-cards.scss'),
  },

  {
    name: 'project-content-row',
    
    styles: () => import('../../src/scss/modules/project-content-row.scss'),
  },

  {
    name: 'project-link-list',
    
    styles: () => import('../../src/scss/modules/project-link-list.scss'),
  },

  {
    name: 'about-us-block',
    loader: () => import('./modules/about-us-block'),
    styles: () => import('../../src/scss/modules/about-us-block.scss'),
  },

  {
    name: 'statistic-carousel-row',
    loader: () => import('./modules/statistic-carousel-row'),
    styles: () => import('../../src/scss/modules/statistic-carousel-row.scss'),
  },

  {
    name: 'certifications-modal',
    loader: () => import('./modules/certifications-modal'),
    styles: () => import('../../src/scss/modules/certifications-modal.scss'),
  },

  {
    name: 'video-modal',
    loader: () => import('./modules/video-modal'),
    styles: () => import('../../src/scss/modules/video-modal.scss'),
  },

  {
    name: 'video-card',
    
    styles: () => import('../../src/scss/modules/video-card.scss'),
  },

  {
    name: 'video-carousel',
    loader: () => import('./modules/video-carousel'),
    styles: () => import('../../src/scss/modules/video-carousel.scss'),
  },

  {
    name: 'testimonial-card',
    
    styles: () => import('../../src/scss/modules/testimonial-card.scss'),
  },

  {
    name: 'media-gallery',
    loader: () => import('./modules/media-gallery'),
    styles: () => import('../../src/scss/modules/media-gallery.scss'),
  },

  {
    name: 'video-carousel-list-row',
    loader: () => import('./modules/video-carousel-list-row'),
    styles: () => import('../../src/scss/modules/video-carousel-list-row.scss'),
  },

  {
    name: 'video-carousel-list-card',
    
    styles: () => import('../../src/scss/modules/video-carousel-list-card.scss'),
  },

  {
    name: 'quiz-row',
    loader: () => import('./modules/quiz-row'),
    styles: () => import('../../src/scss/modules/quiz-row.scss'),
  },

  {
    name: 'ventilation-calculator',
    loader: () => import('./modules/ventilation-calculator'),
    styles: () => import('../../src/scss/modules/ventilation-calculator.scss'),
  },

  {
    name: 'parts-of-roof',
    
    styles: () => import('../../src/scss/modules/parts-of-roof.scss'),
  },

  {
    name: 'product-benefits-row',
    
    styles: () => import('../../src/scss/modules/product-benefits-row.scss'),
  },

  {
    name: 'magento-promo-row-one',
    
    styles: () => import('../../src/scss/modules/magento-promo-row-one.scss'),
  },

  {
    name: 'virtual-home-remodeler-row',
    
    styles: () => import('../../src/scss/modules/virtual-home-remodeler-row.scss'),
  },

  {
    name: 'magento-promo-row-two',
    
    styles: () => import('../../src/scss/modules/magento-promo-row-two.scss'),
  },

  {
    name: 'shingle-specifications-table',
    
    styles: () => import('../../src/scss/modules/shingle-specifications-table.scss'),
  },

  {
    name: 'review-embed',
    
    styles: () => import('../../src/scss/modules/review-embed.scss'),
  },

  {
    name: 'product-feature-warranty-row',
    
    styles: () => import('../../src/scss/modules/product-feature-warranty-row.scss'),
  },

  {
    name: 'blog-content-container',
    
    styles: () => import('../../src/scss/modules/blog-content-container.scss'),
  },

  {
    name: 'tag-row',
    
    styles: () => import('../../src/scss/modules/tag-row.scss'),
  },

  {
    name: 'author-feature-row',
    
    styles: () => import('../../src/scss/modules/author-feature-row.scss'),
  },

  {
    name: 'related-article-row',
    
    styles: () => import('../../src/scss/modules/related-article-row.scss'),
  },

  {
    name: 'document-product-row',
    
    styles: () => import('../../src/scss/modules/document-product-row.scss'),
  },

  {
    name: 'installation-steps-row',
    loader: () => import('./modules/installation-steps-row'),
    styles: () => import('../../src/scss/modules/installation-steps-row.scss'),
  },

  {
    name: 'faq-component-row',
    
    styles: () => import('../../src/scss/modules/faq-component-row.scss'),
  },

  {
    name: 'related-components-and-accessories-row',
    
    styles: () => import('../../src/scss/modules/related-components-and-accessories-row.scss'),
  },

  {
    name: 'related-product-row',
    
    styles: () => import('../../src/scss/modules/related-product-row.scss'),
  },

  {
    name: 'category-selection-bar',
    loader: () => import('./modules/category-selection-bar'),
    
  },

  {
    name: 'chairmans-circle-row',
    
    styles: () => import('../../src/scss/modules/chairmans-circle-row.scss'),
  },

  {
    name: 'related-profiles-row',
    
    styles: () => import('../../src/scss/modules/related-profiles-row.scss'),
  },

  {
    name: 'featured-blog-listing',
    loader: () => import('./modules/featured-blog-listing'),
    styles: () => import('../../src/scss/modules/featured-blog-listing.scss'),
  },

  {
    name: 'product-iframe-row',
    loader: () => import('./modules/product-iframe-row'),
    styles: () => import('../../src/scss/modules/product-iframe-row.scss'),
  },

  {
    name: 'shingle-comparison-table',
    loader: () => import('./modules/shingle-comparison-table'),
    styles: () => import('../../src/scss/modules/shingle-comparison-table.scss'),
  },

  {
    name: 'campaign-form-container',
    
    styles: () => import('../../src/scss/modules/campaign-form-container.scss'),
  },

  {
    name: 'section-navigation',
    loader: () => import('./modules/section-navigation'),
    
  },

  {
    name: 'image-carousel-card',
    
    styles: () => import('../../src/scss/modules/image-carousel-card.scss'),
  },

  {
    name: 'image-carousel-row',
    loader: () => import('./modules/image-carousel-row'),
    styles: () => import('../../src/scss/modules/image-carousel-row.scss'),
  },

  {
    name: 'skip-to-main-content',
    loader: () => import('./modules/skip-to-main-content'),
    
  },

  {
    name: 'nearby-links',
    loader: () => import('./modules/nearby-links'),
    styles: () => import('../../src/scss/modules/nearby-links.scss'),
  },

  {
    name: 'blog-sticky-jumplinks',
    loader: () => import('./modules/blog-sticky-jumplinks'),
    styles: () => import('../../src/scss/modules/blog-sticky-jumplinks.scss'),
  },

  {
    name: 'related-blog-articles',
    
    styles: () => import('../../src/scss/modules/related-blog-articles.scss'),
  },

  {
    name: 'featured-system',
    
    styles: () => import('../../src/scss/modules/featured-system.scss'),
  },

  {
    name: 'dynamic-grid-container',
    
    styles: () => import('../../src/scss/modules/dynamic-grid-container.scss'),
  },

  {
    name: 'responsive-card-row-with-text-link',

    styles: () => import('../../src/scss/modules/responsive-card-row-with-text-link.scss'),
  },

  {
    name: 'cta-card-with-optional-links',

    styles: () => import('../../src/scss/modules/cta-card-with-optional-links.scss'),
  },

  {
    name: 'cta-card-link',
    
    styles: () => import('../../src/scss/modules/cta-card-link.scss'),
  }
];

export default [...modulesScaffold];
